export default "__VITE_ASSET__BiBTg4QA__"